import { DateTime } from "@easepick/bundle";
import { codeMasterType } from "../../../config/constants";
import codeMasterModel from "../../common/code-master.model";
import modelBaseV2 from "../../model-base-v2.model";


const SAVINADirectInterfaceModel = {
  search: (body) => {
    return modelBaseV2.post('/api/sms/vnIntf/logs', { body });
  },

  getListVendor: () => {
    return modelBaseV2.get('/api/sms/vnIntf/vendors');
  },

  downloadExcel: (body) => {
    const fileName = `[SAVINA]_Direct_Interface_Logs_${DateTime.now()}`;

    return modelBaseV2.postDownload('/api/sms/vnIntf/logs/export', { body }, fileName);
  },
}

export default SAVINADirectInterfaceModel;